module.exports = __webpack_public_path__ + "static/media/Harborview1.33a49fff.jpg";